import { placementActivityService } from './placement-activity.service';
import {
  PlacementActivityActions,
  PlacementActivityMutations,
  PlacementActivityGetters
} from './placement-activity.keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    placementActivityInputFields: {
      rangeStart: '',
      rangeEnd: '',
      branchName: '',
      divisionAbbr: '',
      referral: false,
      clientId: '',
      entity: ''
    },
    placementActivityList: [],
    placementActivityCount: null,
    isPlacementActivityLoading: false,
    activityResultRecordCount: 0,
    activityResultsPagination: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};
export const placementActivityStore = {
  state: getInitialState(),
  getters: {
    [PlacementActivityGetters.IsPlacementActivityLoading]: state => {
      return state.isPlacementActivityLoading;
    },
    [PlacementActivityGetters.PlacementActivityInputFields]: state => {
      return state.placementActivityInputFields;
    },
    [PlacementActivityGetters.PlacementActivityList]: state => {
      return state.placementActivityList;
    },
    [PlacementActivityGetters.PlacementActivityCount]: state => {
      return state.placementActivityCount;
    },
    [PlacementActivityGetters.ActivityResultsPerPage]: state => {
      return state.activityResultsPagination.recordsPerPage;
    },
    [PlacementActivityGetters.ActivityResultsOffset]: state => {
      return state.activityResultsPagination.offset;
    },
    [PlacementActivityGetters.ActivityResultsRecordCount]: state => {
      return state.activityResultRecordCount;
    }
  },
  mutations: {
    [PlacementActivityMutations.SetPlacementActivityLoading](state, isLoading = true) {
      state.isPlacementActivityLoading = isLoading;
    },
    [PlacementActivityMutations.SetPlacementActivityInputFields](state, placementActivityInput) {
      state.placementActivityInputFields = { ...placementActivityInput };
    },
    [PlacementActivityMutations.SetPlacementActivityList](state, placementActivityList) {
      state.placementActivityList = placementActivityList;
    },
    [PlacementActivityMutations.SetPlacementActivityCount](state, payload) {
      if (state.placementActivityCount === null) {
        const obj = {};
        obj[payload.key] = payload.data;
        state.placementActivityCount = { ...obj };
      } else {
        state.placementActivityCount[payload.key] = payload.data;
      }
    },
    [PlacementActivityMutations.SetActivityPaginationParameters](state, params) {
      state.activityResultsPagination = { ...params };
    },
    [PlacementActivityMutations.SetActivityRecordCount](state, count) {
      state.activityResultRecordCount = count;
    }
  },
  actions: {
    [PlacementActivityActions.SetPlacementActivityInputFields]({ commit }, placementActivityInput) {
      commit(PlacementActivityMutations.SetPlacementActivityInputFields, placementActivityInput);
    },
    [PlacementActivityActions.RetrievePlacementActivityList]({ state, commit, dispatch }) {
      dispatch(
        PlacementActivityActions.RetrieveActivityRecordCount,
        state.placementActivityInputFields
      );

      return placementActivityService
        .getPlacementActivity(state.placementActivityInputFields, state.activityResultsPagination)
        .then(placementActivityList =>
          commit(PlacementActivityMutations.SetPlacementActivityList, placementActivityList)
        )
        .catch(err => {
          commit(PlacementActivityMutations.SetPlacementActivityLoading, false);
          dispatch(TolErrorsActions.SetError, {
            err,
            message: i18n.t('placementActivity.errors.retrievePlacementActivity')
          });
        });
    },
    [PlacementActivityActions.RetrievePlacementActivityCount]({ state, commit, dispatch }) {
      //const auth = localStorage.getItem('token');
      commit(PlacementActivityMutations.SetPlacementActivityLoading);
      return placementActivityService
        .getPlacementActivitySummary(state.placementActivityInputFields, {
          summaryType: 'range'
        })
        .then(range => {
          commit(PlacementActivityMutations.SetPlacementActivityCount, {
            data: range,
            key: 'givenRange'
          });
          return placementActivityService.getPlacementActivitySummary(
            state.placementActivityInputFields,
            {
              summaryType: 'years'
            }
          );
        })
        .then(years => {
          commit(PlacementActivityMutations.SetPlacementActivityCount, {
            data: years,
            key: 'yearly'
          });
          return placementActivityService.getPlacementActivitySummary(
            state.placementActivityInputFields,
            {
              summaryType: 'months'
            }
          );
        })
        .then(months => {
          commit(PlacementActivityMutations.SetPlacementActivityCount, {
            data: months,
            key: 'monthly'
          });
          return placementActivityService.getPlacementActivitySummary(
            state.placementActivityInputFields,
            {
              summaryType: 'quarters'
            }
          );
        })
        .then(quarters => {
          commit(PlacementActivityMutations.SetPlacementActivityCount, {
            data: quarters,
            key: 'quarterly'
          });
          return placementActivityService.getPlacementActivitySummary(
            state.placementActivityInputFields,
            {
              summaryType: 'weeks'
            }
          );
        })
        .then(weeks => {
          commit(PlacementActivityMutations.SetPlacementActivityCount, {
            data: weeks,
            key: 'weekly'
          });
        })
        .then(() => commit(PlacementActivityMutations.SetPlacementActivityLoading, false))
        .catch(err => {
          commit(PlacementActivityMutations.SetPlacementActivityLoading, false);
          dispatch(TolErrorsActions.SetError, {
            err,
            message: i18n.t('placementActivity.errors.retrievePlacementActivity')
          });
        });
    },
    [PlacementActivityActions.SetActivityPaginationParameters]({ commit, dispatch }, params) {
      commit(PlacementActivityMutations.SetActivityPaginationParameters, params);
      dispatch(PlacementActivityActions.RetrievePlacementActivityList);
    },
    [PlacementActivityActions.RetrieveActivityRecordCount]({ state, commit }) {
      return placementActivityService
        .getPlacementActivityRecordCount(state.placementActivityInputFields)
        .then(count => {
          commit(PlacementActivityMutations.SetActivityRecordCount, count);
        });
    }
  }
};
